import { Component } from '@angular/core';
import { LocationService } from '../../services/location.service';
import { DataService } from '../../services/data.service';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormArray } from '@angular/forms'
import { OperatorService } from "../../services/operator.service";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { NgbModalOptions, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  NgInformationModalContent,
  NgYesNoModalContent
} from "../../util/components/modalcomponent/modal-content";
@Component({
  selector: 'app-smart-notification',
  // imports:[FormsModule,CommonModule,MatSelectModule,MatFormFieldModule,MatIconModule],
  templateUrl: './smart-notification.component.html',
  styleUrls: ['./smart-notification.component.css']
})
export class SmartNotificationComponent {
  messageData: any
  ruleFg:FormGroup
  bHoursList:any
  chargingstations:any
  weekval: any
  startDate: any;
  endDate: any;
  popupData:any
  showPopup = false;

  locationSchedule={
    status: "",
    scheduleFor: "OUT",
    scheduleStart:"",
    scheduleEnd: "",
    chargingStations: ['all']}

    maxpower: any
    isScheduledelete: boolean = false
constructor(private LocationService:LocationService,    private data: DataService,
  private fb: FormBuilder,    private ngbModalService: NgbModal,

  ){
    this.data.portMessage.subscribe((message: any) => this.messageData = message)
// this.agentList()





  this.startDate = "00:00"
  this.endDate = "23:59"
 
  this.weekval = ["0", "1", "2", "3", "4", "5", "6"]
  this.smartList()
  this.getChargerlist()

  this.ruleFg = this.fb.group({
    "policyId": [this.messageData.policyId],
    "schedule": this.fb.array([
      // this.fb.group({
        
      //   "powerMode": [this.maxpower,[Validators.required]],
      //   "scheduleFor": ['',[Validators.required]],
      //   "schedule": [this.weekval,[Validators.required]],
      //   "scheduleStart": [this.startDate,[Validators.required]],
      //   "scheduleEnd": [this.endDate,[Validators.required]],
      //   "chargingStations": [,[Validators.required]],
      //   "uuid":[]

      // })
    ])
  })
}


get schedule() {
    
  return this.ruleFg.get('schedule') as FormArray;
}
  checkAllWeek() {
    let val = this.weekval;
    if (val.includes("0")) {
      this.weekval = ["0", "1", "2", "3", "4", "5", "6", "7"]
    }
    if (val[0] === "1" && val[1] === "2" && val[2] === "3" && val[3] === "4" && val[4] === "5" && val[5] === "6" && val[6] === "7") {

      this.weekval = ["", "", "", "", "", "", "", ""]
    }
  }
  getChargerlist() {
    let request: any = {};
    request['location'] = this.messageData.uuid
    this.getChargerlistbylocation(request)
  }

  getChargerlistbylocation(request: any){
    this.LocationService
      .getChargerlistbylocation(request)
      .subscribe({
        next: (res: any) => {
          if (res) {
            const data = res
          

            this.chargingstations = data;

            this.chargingstations= this.chargingstations.filter((item:any)=>item.status==="A")
            this.selectchargingStation()

          } else {

          }
        }, error: (err) => {

          console.error("Error in fetching all getChargingStationlist");
        }
      }
      )
  }
  clear(item:any){
    this.schedule.removeAt(item);

  }

  openPopup(item:any,i:any){
    this.showPopup = true;
    this.popupData=item
   
    this.popupData.dow=this.popupData.dow.split(':')
    this.popupData.dow= item.dow.map((item: string) => {
      switch (item) {
        case '1': return "Monday";
        case '2': return "Tuesday";
        case '3': return "Wednesday";
        case '4': return "Thursday";
        case '5': return "Friday";
        case '6': return "Saturday";
        case '7': return "Sunday";

        default: return "";
      }})
  }
  
  regSchedule(){

  }
  agent:any={
    
    number:''
  }
  addBusinessHours(){

let request:any={
  "agent" : {number:this.agent.number.join(',')},
  // "type":this.locationSchedule?.scheduleFor,
  //   "dow":this.weekval?.join(':'),
  //   "fromTime":this.startDate,
  //   "toTime":this.endDate,
    "chargers":this.locationSchedule.chargingStations.filter((item:any)=>item!='all'),
    // "chargers":this.locationSchedule?.chargingStations,
    status:'A'
}
this.saveSmartNotification(request)

  }
  AddEnergyrules() {
   
    if(this.weekval.includes("0","1","2","3","4","5","6","7","8")){
      this.weekval.includes("0")
      }
    this.weekval= this.weekval.map((item: string) => {
      switch (item) {
        case '0': return "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday";
        case '1': return "Monday";
        case '2': return "Tuesday";
        case '3': return "Wednesday";
        case '4': return "Thursday";
        case '5': return "Friday";
        case '6': return "Saturday";
        case '7': return "Sunday";
        default: return "";
      }})
    this.schedule.push(this.fb.group({
           //"status": [this.energyrules.status,[Validators.required]],
          "powerMode": [this.maxpower,[Validators.required]],
          "scheduleFor": [this.locationSchedule.scheduleFor,[Validators.required]],
          "schedule": [this.weekval,[Validators.required]],
          "scheduleStart": [this.startDate,[Validators.required]],
          "scheduleEnd": [this.endDate,[Validators.required]],
          "chargingStations": [this.locationSchedule.chargingStations,[Validators.required]],
          
    }))
  
     this.locationSchedule.status="" 
      this.locationSchedule.chargingStations=[] 
      this.startDate = "00:00"
      this.endDate = "23:59"  
     this.weekval = ["0", "1", "2", "3", "4", "5", "6", "7"]
      this.maxpower=""
    
    this.isScheduledelete = true;
      
    
  }
  removeEnergyrules(i: any) {
    this.schedule.removeAt(i);
  }
  EnergydisableSave(){
    let isDisableSave: boolean = true;
    
        if (this.locationSchedule.scheduleFor  && this.locationSchedule.chargingStations  && this.endDate && this.startDate && this.weekval&&!this.disable) {
          
            isDisableSave = false;
          
        
      }
      return isDisableSave;
  }
  closePopup() {
    this.showPopup = false;
    
  }


disable:boolean=false
saveSmartNotification(request:any) {

this.disable=true
    
        let ngmodaloptions: NgbModalOptions = {};

    this.LocationService.saveSmartNotification(request,this.messageData.stationId)
      .subscribe({
        next: (res) => {
          if(res.status==201){
  const modalRef = this.ngbModalService.open(
            NgInformationModalContent,
            ngmodaloptions
          );
          modalRef.componentInstance.title = "Information";
          modalRef.componentInstance.message = "Save Smart Notification Successfully!!";
          modalRef.componentInstance.btnCLass = "btn-info";
          modalRef.result.then(
            result => {
              if (result == "ok") {
                // this.saveEvent.emit({ success: true });
                // this.isDetailScreen = false;
              }
            }, reason => {
              // this.data = data["result"];
              // this._data = this.tools.copyFullObject(this.data);
            }
          );



          this.disable=false
          this.smartList()
            //  this.toastMsgService.setMsg({ msg: "Save Smart Notification Successfully!", msgTitle: "Success", msgType: "I" });

             this.locationSchedule.status="" 
             this.locationSchedule.chargingStations=[]  
            //  this.startDate = "00:00"
            //  this.endDate = "23:59"  
            // this.weekval = [ "1", "2", "3", "4", "5", "6","7"]
            //  this.maxpower=""
          }else{
            this.disable=false

            // this.toastMsgService.setMsg({ msg: "Failed to Save!", msgTitle: "Warning", msgType: "W" });

          }
          // if (res.status == 201 ) {
          //   this.toastMsgService.setMsg({ msg: "Save Business Hour Successfully!", msgTitle: "Success", msgType: "I" });
          //   // this.router.navigate(["/sign-in"]);
          // } else {
          //   const body: any = res.body;
          // }
        }, error: (err) => {

            const modalRef = this.ngbModalService.open(
          NgInformationModalContent,
          ngmodaloptions
        );
        modalRef.componentInstance.title = "Error";
        modalRef.componentInstance.message = "Failed to save!";
        modalRef.componentInstance.btnCLass = "btn-warning";
        modalRef.result.then(
          result => {},
          reason => {}
        );
          this.disable=false

        }
      }
      )
  }
  selectchargingStation(){
    let all:any='all'
    
    if(all.includes(this.locationSchedule.chargingStations)){

      this.locationSchedule.chargingStations=['all']
      this.chargingstations.forEach((charger:any)=>{
        this.locationSchedule.chargingStations.push(charger.ocppId);
})


    }
    

  }
  enterAll(){
    let all:any='all'
    if(all.includes(this.locationSchedule.chargingStations)){

      this.locationSchedule.chargingStations=['all']
      this.chargingstations.forEach((charger:any)=>{
        this.locationSchedule.chargingStations.push(charger.ocppId);})

    }else if(!all.includes(this.locationSchedule.chargingStations)){
      this.locationSchedule.chargingStations=[]

    }
  }
  onSelectionChange() {
    const allIndex = this.locationSchedule.chargingStations.indexOf('all');

    if (allIndex > -1) {
      // "All" is selected, select all items
      // this.locationSchedule.chargingStations = ['all', ...this.chargingstations.map((station:any) => station.ocppId)];
      this.locationSchedule.chargingStations=this.locationSchedule.chargingStations = ['all'].concat(this.chargingstations.map((station: any) => station.ocppId));
    } else if (this.locationSchedule.chargingStations.length === 0) {
      // "All" is deselected, deselect all items
      this.locationSchedule.chargingStations = [];
    } else if (this.locationSchedule.chargingStations.length !== this.chargingstations.length) {
      // Ensure "All" is removed when not all items are selected
      const index = this.locationSchedule.chargingStations.indexOf('all');
      if (index !== -1) {
        this.locationSchedule.chargingStations.splice(index, 1);
      }
    }
  }
  smartList(){
    this.LocationService
      .smartNotificationsList(this.messageData.stationId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            const data = res
          
            this.bHoursList = data;

          } else {

          }
        }, error: (err) => {

          console.error("Error in fetching all Business Hours");
        }
      }
      )
  }

  deleteSmartNotification(id:any){
  //   this.dialogService.open({msg : "Are you sure you want to delete Smart Notification?",title : "Confirmation",buttonType : "YesNo"})
       
  // this.dialogService.onResponse((response :  string) => {
   
  //   if(response=="Yes") {
        let ngmodaloptions: NgbModalOptions = {};

  const modalRef = this.ngbModalService.open(
            NgInformationModalContent,
            ngmodaloptions
          );
          modalRef.componentInstance.title = "Confirmation";
          modalRef.componentInstance.message = "Are you sure you want to delete Smart Notification!";
          modalRef.componentInstance.btnCLass = "btn-info";
          modalRef.result.then(
            result => {
              if (result == "ok") {
                this.LocationService
      .deleteSmartNotifications(id)
      .subscribe({
        next: (res: any) => {
          
        this.smartList()
          // this.toastMsgService.setMsg({ msg: "Smart Notification Deleted Successfully!", msgTitle: "Success", msgType: "I" });

          if (res) {
           

          } else {

          }
        }, error: (err) => {
          console.log(err)
          // this.toastMsgService.setMsg({ msg: "Failed to Delete!", msgTitle: "Warning", msgType: "W" });

        }
      }
      )
                // this.saveEvent.emit({ success: true });
                // this.isDetailScreen = false;
              }
            }, reason => {
              // this.data = data["result"];
              // this._data = this.tools.copyFullObject(this.data);
            }
          );
    
    // }})
  }
  
  agentData:any=[]

}
